import { State } from 'pixi.js';
import { Presentation } from '../../../../core/gameflow/controller/Presentation';
import { StateHandler } from '../../../../core/utils/StateHandler';
import { SanEngineManager } from '../../../engine/SanEngineManager';
import { RevealerManager } from '../../../modules/revealer/RevealerManager';
import { SanQuentin2 } from '../../../SanQuentin2';
import { SanJumpData } from '../../../server/base/IData';
import { GameData } from '../../../server/data/GameData';
import { InitData } from '../../../server/data/InitData';
import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { SoundManager } from '../../../config/sound/SoundManager';
import { SoundConfig } from '../../../config/sound/SoundConfig';
import { IntroPresentation } from '../intro/IntroPresentation';
import { GameSetting } from '../../../../core/setting/GameSetting';
import { TranslationConfig } from '../../../config/translate/TranslationConfig';

enum RestoreStates {
    INTRO_PRES = "INTRO_PRES",
    TRANS_SETUP2 = "TRANS_SETUP2",
    GAMBLE_CLICKED = "GAMBLE_CLICKED",
    GAMBLE_RESULT = "GAMBLE_RESULT",
    OPEN_BARS = "OPEN_BARS",
    RESTORE_FS = "RESTORE_FS"
}

export class RestorePresentation extends Presentation {

    private state:StateHandler = new StateHandler(undefined,new Map<String, Function >([
        [RestoreStates.INTRO_PRES, () => this.onRestoreSetup()],
        [RestoreStates.GAMBLE_CLICKED, () => this.playerPickedGamble()],
        [RestoreStates.GAMBLE_RESULT, () => this.showRestoreClick()],
        [RestoreStates.TRANS_SETUP2, () => this.onNext()],
        [RestoreStates.OPEN_BARS, () => this.onOpenBars()],
        [RestoreStates.RESTORE_FS, () => this.onRestoreFS()]
    ]));

    private barsOpened:boolean[];

    private isSetup:boolean;
    private isFS:boolean;

    private showFirstSetup:boolean;
    private showResultTransit:boolean;
    private showResultGambleTransit:boolean;

    private jumpData:SanJumpData[];

    private totWin:number = 0;
    private totWinBel:boolean = false;

    checkForActivation(data: InitData): boolean { return data.isRestoreState; }

    setInitData(init:InitData | GameData){
        super.setInitData(init);
        this.barsOpened = init.raw.topBottomReelOpened ?? init.raw.bottomRowOpen;

        this.showFirstSetup = init.isFirstFSSetup || init.nextIsFSSetup;
        this.showResultTransit = init.isSecondSetup;
        this.showResultGambleTransit = this.showResultTransit && init.raw.gambleResult === "Failed";

        this.isSetup = init.isFSSetup && !init.isNextFS;

        this.isFS = init.isFreeSpin;
        SanQuentin2.setupPhase.setData(init as GameData);

        this.jumpData = init.Reel.jumpData;

        this.totWin = init.Win.totalWin;
        this.totWinBel = init.Win.isWinBelowStake();

        this.state.set(this.isFS ? RestoreStates.RESTORE_FS : RestoreStates.INTRO_PRES);
        // this.showSpinner = (init.isFSSetup || init.isNormalMode) && !init.isNextFS;
    }

    setGameData(data: InitData): void {
        this.setInitData(data);
    }

    preStart(): void {
        IntroPresentation.introPlayed = true;
        SlotGame.keypadPlugin.setWin(this.totWin, true, this.totWinBel);
        SanQuentin2.overlay.introApplyLogo();
        SanQuentin2.xWaysCounter.counterActive(false);

        SanQuentin2.overlay.hideLogo();
        SanQuentin2.xWaysCounter.hide();
    }

    createPresentation(): void {
        this.state.triggerState();
    }

    onRestoreSetup():void{

        if(this.showFirstSetup){
            SanEngineManager.isGambleMode = true;
            SoundManager.stopSoundEffect(SoundConfig.BASE_GAME_AMBIANCE);
            SoundManager.PlayAmbience(SoundConfig.FS_INTRO_AMBIANCE);
            SoundManager.playSoundEffect(SoundConfig.FS_START_RIFF);
   
            SanQuentin2.background.triggerTransition(true);
            SanQuentin2.reelEngineManager.ZoomIn(true,0.75);
            SanQuentin2.background.setBgGFX(1,1.5)
            this.timeline.add(SanQuentin2.setupPhase.playIntro(),0.75);

            this.barsOpened.forEach((v,rIndex) => {
                this.timeline.add(SanEngineManager.getReel(rIndex).reelLocker(true),0);
                this.timeline.add(RevealerManager.getTopBar(rIndex).closeBar(),0)
                this.timeline.add(RevealerManager.getBotBar(rIndex).closeBar(),0)
            });
            this.timeline.add(() => {
                SanEngineManager.RSAll((reel,sym) => {
                    sym.setSymbol("X");
                })
            })

            if(this.showResultGambleTransit) this.state.set(RestoreStates.GAMBLE_CLICKED)
            else if(this.showResultTransit) this.state.set(RestoreStates.TRANS_SETUP2);
            else this.setPlayable(false);
        }else{
            SanEngineManager.isGambleMode = true;
            SoundManager.stopSoundEffect(SoundConfig.BASE_GAME_AMBIANCE);
            SoundManager.PlayAmbience(SoundConfig.FS_GAME_AMBIANCE);

            if(this.isSetup)
                SoundManager.playSoundEffect(SoundConfig.FS_START_RIFF);

            SanQuentin2.background.onRestore(true);
            SanQuentin2.reelEngineManager.setFSReelAreaBG(true);
            this.barsOpened.forEach((v,rIndex) => {
                if(v){
                    this.timeline.add(RevealerManager.getTopBar(rIndex).openBar(),0)
                    this.timeline.add(RevealerManager.getBotBar(rIndex).openBar(),0)
                }else if(this.isSetup){
                    this.timeline.add(SanEngineManager.getReel(rIndex).reelLocker(true),0);
                    this.timeline.add(RevealerManager.getTopBar(rIndex).closeBar(),0)
                    this.timeline.add(RevealerManager.getBotBar(rIndex).closeBar(),0)
                }
                SanEngineManager.getReel(rIndex).AllSymbols.forEach(s => {
                    if(this._initData.Reel.evalReel[rIndex][s.posID[0]] === "Z")
                        s.setSymbol("Z");
                    else
                        s.setSymbol("X");
                })
            });
            SanQuentin2.jumpingWildController.createRestoreJW(this.jumpData, false);
            this.setPlayable(false);
        }
    }

    playerPickedGamble() {
        this.timeline.add(SanQuentin2.setupPhase.ClickedGamble());
        this.state.set(RestoreStates.GAMBLE_RESULT)
    }

    showRestoreClick():void{
        this.timeline.add(SanQuentin2.setupPhase.ShowClickResult());
        this.state.set(RestoreStates.TRANS_SETUP2)
    }

    public onNext():void{
        SanQuentin2.reelEngineManager.applyBars(false);
        SanQuentin2.reelEngineManager.setFSReelAreaBG(true);
        this.timeline.add(SanQuentin2.setupPhase.NextSetup());
        this.timeline.add(SanQuentin2.reelEngineManager.ZoomIn(false,0.1),0.5);
        this.timeline.add(SanQuentin2.postCounter.playText(GameSetting.translate(TranslationConfig.FREESPINS_COLLECTED) + "\n" + this._initData.raw.freespinsLeft));
        this.state.set(RestoreStates.OPEN_BARS);
    }

    public onOpenBars():void{
        let del = 0;

        SanEngineManager.RAll((reel) => {
            if(this.barsOpened[reel.reelID]){
                this.timeline.add(reel.reelLocker(false), del)
                this.timeline.add(RevealerManager.getTopBar(reel.reelID).openBar(),del)
                this.timeline.add(RevealerManager.getBotBar(reel.reelID).openBar(),del)
            }
            this.timeline.add(() => SanQuentin2.setupPhase.showCaseEnableVal(reel.reelID,this.barsOpened[reel.reelID]),del)
            del += 0.2;
        })
        this.setPlayable(false);
    }

    onRestoreFS():void{
        SanQuentin2.xWaysCounter.counterActive(true,true);
        SanQuentin2.reelEngineManager.setFSReelAreaBG(true);
        SanQuentin2.background.onRestore(true);

        SoundManager.stopSoundEffect(SoundConfig.BASE_GAME_AMBIANCE);
        SoundManager.PlayAmbience(SoundConfig.FS_GAME_AMBIANCE);
        
        SanEngineManager.RAll((reel) => {
            if(this.barsOpened[reel.reelID]){
                RevealerManager.getTopBar(reel.reelID).openBar();
                RevealerManager.getBotBar(reel.reelID).openBar();
            }
        });

        SanQuentin2.jumpingWildController.createRestoreJW(this.jumpData);
        SanQuentin2.jumpingWildController._firstTimeApply = false;
        this.setPlayable(false);
    }
}